import { DataTable } from "@/components/custom/data-table";
import { Box, Stack, styled } from "@mui/material";
import CustomSearchInput from "@/components/custom/custom-search-input";
import { useSearchParams } from "react-router-dom";
import CustomPagination from "@/components/custom/custom-pagination";
import { useAllProfitCalculation } from "@/hooks/use-profit-calculation";
import { getProfitCalcColumns } from "./_components/profit-calc-column";

const RootWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Card = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const ProfitCalculation = () => {
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search") || "";
  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);

  const queryParams = {
    page: currentPage,
    size: pageSize,
    search: searchValue,
  };

  const {
    data: profit,
    isLoading,
    isError,
  } = useAllProfitCalculation(true, queryParams);

  return (
    <RootWrapper>
      <Card>
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={3}>
            <CustomSearchInput
              paramKey="search"
              placeholder="Search profit calculation..."
            />
          </Stack>
        </Stack>

        <DataTable
          data={profit?.data?.data ?? []}
          columns={getProfitCalcColumns()}
          isLoading={isLoading}
          isError={isError}
        />
        <CustomPagination
          total={profit?.data?.totalCount ?? 0}
          perPageOptions={[5, 10, 20, 50, 100]}
        />
      </Card>
    </RootWrapper>
  );
};

export default ProfitCalculation;
